import { Component, inject, Input } from "@angular/core";
import { HashService } from "../../services/hash.service";
import { NgClass } from '@angular/common';

@Component({
  selector: "ui-avatar",
  templateUrl: "./ui-avatar.component.html",
  styleUrl: "./ui-avatar.component.scss",
  imports: [
    NgClass,
  ],
})
export class UiAvatarComponent {
  private hashSvc = inject(HashService);

  @Input() fullName?: string;
  @Input() size: 'xs' | 's-' | 's' | 'm' | 'profile' = 'm';
  @Input() shape: 'circle' | 'rounded' = 'circle';
  @Input() variant: 'default' | 'ring' = 'default';
  @Input() imageUrl?: string;
  @Input('class') hostClass?: string;
  @Input() extraClass?: string;

  get classes(): string[] {
    return ['avatar', this.size, `shape-${this.shape}`, this.hostClass, this.extraClass].filter(Boolean);
  }

  get fullNameSafe(): string{
    return this.fullName || 'No Name'
  }

  getInitials(): string {
    const source = this.fullNameSafe;
    const parts = source
      .split(' ')
      .map((x) => x.trim())
      .filter((x) => !!x);

    if (!parts.length) {
      return '??';
    }

    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }

    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }

  
  getRingBoxShadow(): string | null {
    if (this.variant !== 'ring') return null;
    return this.hashSvc.avatarRingShadow(this.fullNameSafe);
  }

  getAvatarColor(): string {
    return this.hashSvc.avatarColor(this.fullNameSafe);
  }
}
